/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DailyNavMarketDataJob = {
  provider_code: string;
  capability: string;
  scheduled_for: string;
  status: DailyNavMarketDataJob.status;
  estimated_completion_at: string | null;
};
export namespace DailyNavMarketDataJob {
  export enum status {
    NOT_STARTED = 'NOT_STARTED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
    FAILED = 'FAILED',
  }
}

